import { IonButton, IonCol, IonImg, IonRow } from "@ionic/react";
import { VideoBackType, titleSection } from "./Video";

interface IReaderButtonProps {
  video: VideoBackType;
  isChar: boolean;
}

const ReaderButton: React.FC<IReaderButtonProps> = ({ video, isChar }) => {
  const isDisabled = !(video?.pages?.length > 0 || video.fileUrl.length > 0);

  return (
    <>
      <IonRow className="ion-justify-content-left">
        {titleSection(
          (isChar ? "1" : "3") + " Les ressources de technologie: ",
          "revois le cours"
        )}
      </IonRow>

      <IonRow
        className="ion-justify-content-left flex ion-align-items-center"
        style={{
          position: "relative",
          padding: "20px 0 20px 5px",
        }}
      >
        <IonCol
          size-lg="2"
          size-sm="2"
          size="2"
          style={{ position: "absolute" }}
        >
          <IonImg
            alt="book icon"
            src="https://cdn-icons-png.flaticon.com/512/2702/2702134.png"
          ></IonImg>
        </IonCol>
        <IonCol>
          <IonRow className="ion-justify-content-center flex ion-align-items-center">
            <IonButton
              id="open-modal-reader"
              disabled={isDisabled}
              shape="round"
              color={isDisabled ? "dark" : "secondary"}
              style={{ width: "50%" }}
              expand="block"
            >
              Lire
            </IonButton>
          </IonRow>
        </IonCol>
      </IonRow>
    </>
  );
};

export default ReaderButton;
